import React from 'react'
import { Element } from './'
import { i18nText } from '../../../Services';
import './section.css'

export const Section = props => {
    const { element } = props;

    return (
        <div className="section">
            {(i18nText.exists(element.title, element.subtitle)) && <div className="section-header">
                {i18nText.exists(element.title) && <h5 className="section-title">{i18nText.getText(element.title)}</h5>}
                {i18nText.exists(element.subtitle) && <p className="section-subtitle">{i18nText.getText(element.subtitle)}</p>}
            </div>}
            {element.elements && <div className="section-body">
                {element.elements.map((e, eindex) => <Element key={eindex} {...props} element={e}></Element>)}
            </div>}
        </div>
    )
}